import { getValue } from "@utils/lodash";
// import "./filter-form.scss";
// import AddFilterNew from "../AddFilterNew";
import InputField from "@_common/InputRuleFeild";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { useState } from "react";
import ResetSvgComponent from "../../../../assets/svg-components/reset";
import { log } from "console";

export default function AssignTaskFilterForm(props: any) {
  const {
    handleChangeSelect,
    countryList,
    states,
    categoryOfLawList,
    legislationList,
    ruleList,
    request,
    additionalFilter,
    smartFilterList,
    selectedSmartFilterIds,
    handleChangeSelectMulti,

    //loading...
    categoryLawLoading,
    legislationLoading,
    legislationRuleLoading,
    resetInput,

    //entity mapping
    headerList,
    headerLoading,
    levelObj,
    childEntityLoading,
    handleClickEntity,
    urlParams,
    handleChangeEntity,
    handleChangeSelectByValue,

    hideUserFilter,
  } = props;

  // const [selectedState,setSelectedState]=useState<any>({})
  
  return (
    <div
      className={`filter-slidder-wrapper  ${
        props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
      }`}
    >
      <div className="filter-form-wrappper w-100 active border_bottom">
        <div className="filter-form-wrappper__container">
          <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
            <div className="filter-header-left-wrapper d-flex align-items-center">
              <div className="filter-close-wrapper">
                <img
                  src="/images/close-circle.svg"
                  className="img-fluid cursor-pointer"
                  onClick={props.handleFilter}
                />
              </div>
              <div className="filter-title-wrapper">
                <h6 className="filter-form-wrappper__title">Filter</h6>
              </div>

              <div className="filter-module-details-wrapper">
                <div className="filter-module-name">{props.moduleName}</div>
                <div className="filter-submodule-name">
                  {props.subModuleName}
                </div>
              </div>
            </div>

            <div className="filter-header-right-wrapper">
              <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                  onClick={props.reset}
                >
                  <div className="d-flex align-items-center mt--3">
                    <ResetSvgComponent size={24} color={"#5F6368"} /> Reset
                  </div>
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                  onClick={props.handleFilter}
                >
                  Cancel
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                  onClick={props.handleSubmitSmartFilter}
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          {/* <div className="d-flex align-items-center justify-content-between my-3">
            <h6 className="filter-form-wrappper__title">Filter by</h6>
            <img
              src="/images/close-black.svg"
              className="img-fluid cursor-pointer"
              onClick={props.setFilterFormVisibility}
            />
          </div> */}
          <div className="filter-body-wrapper">
            <div className="filter-body-card">
              <div className="filter-card-title">Filter By</div>

              <div className="d-flex justify-content-between flex-column">
                <div className="filter-form-wrappper__location">
                  <div className="d-flex w-100 filter-field-main-wrap">
                    <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                      <label
                        htmlFor="country"
                        className="filter-form-wrappper__label filter-fields-label"
                      >
                        Country
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose Country"
                          className="form-control w-100"
                          name="country_id"
                          id="country_id"
                          options={countryList}
                          value={props.country_ID}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "country_id")
                          }
                          label="Country"
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label filter-fields-label"
                      >
                        State
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose State"
                          className="form-control w-100"
                          name="state_id"
                          id="state_id"
                          label="Last Name"
                          options={states}
                          value={props.state_ID}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "state_id")
                          }
                          // value={states.filter((state:any)=>state.state_id==selectedState.state_id)}         
                          // onChange={(e: any) =>
                          //   {setSelectedState(e);
                          //   handleChangeSelect(e, "state_id")}}
                          isClear
                        />
                      </div>
                    </div>
                  </div>
                  {!getValue(props, `internal`, false) && (
                    <>
                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Category of Law
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={"Choose Category of Law"}
                              options={categoryOfLawList}
                              searchLoading={categoryLawLoading}
                              handleChange={(val: any) =>
                                props.getCategoryLawList(val)
                              }
                              handleClick={(e: any) =>
                                props.handleChangeSelect(
                                  e,
                                  "category_of_law_id"
                                )
                              }
                              value={getValue(props, `cat_ID[${0}]`, {})}
                              label="label"
                              id="id"
                              name="Category of Law"
                              resetInput={resetInput}
                              islear
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="legislation"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Legislation
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={"Choose Legislation"}
                              options={legislationList}
                              searchLoading={legislationLoading}
                              handleChange={(val: any) =>
                                props.getLegislationList(val)
                              }
                              handleClick={(e: any) =>
                                props.handleChangeSelect(e, "legislation_id")
                              }
                              value={getValue(props, `leg_ID[${0}]`, {})}
                              label="label"
                              id="id"
                              name="Legislation"
                              resetInput={resetInput}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Rule
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={"Choose Legislation Rule"}
                              options={ruleList}
                              searchLoading={legislationRuleLoading}
                              handleChange={(val: any) =>
                                props.getLegislationRuleList(val)
                              }
                              handleClick={(e: any) =>
                                props.handleChangeSelect(
                                  e,
                                  "legislation_rule_id"
                                )
                              }
                              value={getValue(props, `rule_ID[${0}]`, {})}
                              label="label"
                              id="id"
                              name="Legislation Rule"
                              resetInput={resetInput}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="filter-form-wrappper__location dynamic-feilds-content-holder">
                  {headerLoading ? (
                    <p className="text-center mt-2">Please wait...</p>
                  ) : getValue(headerList, `length`, 0) > 0 ? (
                    headerList.map((searchObj: object, index: number) => {
                      let selectedLevel =
                        getValue(searchObj, `group_level`, 0) > 0
                          ? getValue(
                              urlParams,
                              `level${parseInt(
                                getValue(searchObj, `group_level`, "")
                              )}`,
                              ""
                            )
                          : "";
                      let currentSelectedItem = selectedLevel.split("_")[0];
                      let selectedValue =
                        getValue(
                          levelObj,
                          `[${getValue(searchObj, `id`, "")}].length`,
                          0
                        ) > 0 &&
                        getValue(
                          levelObj,
                          `[${getValue(searchObj, `id`, "")}]`,
                          []
                        ).filter(
                          (item: any) =>
                            item.id === parseInt(currentSelectedItem)
                        );
                      return (
                        <>
                          <div
                            className={`cursor-pointer dynamic-fields-wrapper`}
                          >
                            <div
                              className="position-relative form-group  align-items-center cursor-pointer mb-0"
                              key={`location-${index}`}
                            >
                              <div className="dynamic-fields-label">
                                {getValue(searchObj, `group_name`, "")}
                              </div>
                              <div>
                                <div className="filter-form-wrappper__location-input mw-100">
                                  <SearchableDropdownSelect
                                    placeholder={`Choose ${getValue(
                                      searchObj,
                                      `group_name`,
                                      ""
                                    )}`}
                                    options={getValue(
                                      levelObj,
                                      `[${getValue(searchObj, `id`, "")}]`,
                                      []
                                    )}
                                    searchLoading={false}
                                    handleChange={(val: any) =>
                                      handleChangeEntity(
                                        val,
                                        getValue(searchObj, `id`, ""),
                                        getValue(searchObj, `group_level`, ""),
                                        index
                                      )
                                    }
                                    handleClick={(e: any) =>
                                      handleClickEntity(
                                        getValue(e, `id`, ""),
                                        getValue(searchObj, `id`, ""),
                                        getValue(searchObj, `group_level`, ""),
                                        index
                                      )
                                    }
                                    value={
                                      getValue(selectedValue, `length`, 0) > 0
                                        ? selectedValue[0]
                                        : ""
                                    }
                                    label="label"
                                    id="id"
                                    name={getValue(searchObj, `group_name`, "")}
                                    // removeClose
                                    resetInput={resetInput}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <br /> */}
                        </>
                      );
                    })
                  ) : (
                    <p>No Entity Mapped</p>
                  )}
                </div>
                {!hideUserFilter && (
                  <div className="filter-form-wrappper__location">
                    <div className="d-flex w-100 filter-field-main-wrap">
                      <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                        <label
                          htmlFor="law"
                          className="filter-form-wrappper__label filter-fields-label"
                        >
                          Executor
                        </label>
                        <div className="filter-form-wrappper__location-input select-dd-new">
                          <SearchableDropdownSelect
                            placeholder={"Choose Executor"}
                            options={props.executorList}
                            searchLoading={props.executorLoading}
                            handleChange={(val: any) =>
                              props.getExecutorList(val)
                            }
                            handleClick={(e: any) =>
                              props.handleChangeSelect(e, "executor")
                            }
                            value={getValue(props, `executor_ID[${0}]`, {})}
                            label="label"
                            id="id"
                            name="Executor"
                            resetInput={resetInput}
                          />
                        </div>
                      </div>
                      <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                        <label
                          htmlFor="legislation"
                          className="filter-form-wrappper__label filter-fields-label"
                        >
                          Evaluator
                        </label>
                        <div className="filter-form-wrappper__location-input select-dd-new">
                          <SearchableDropdownSelect
                            placeholder={"Choose Evaluator"}
                            options={props.evaluatorList}
                            searchLoading={props.EvaluatorLoading}
                            handleChange={(val: any) => props.getEvaluator(val)}
                            handleClick={(e: any) =>
                              props.handleChangeSelect(e, "evaluator")
                            }
                            value={getValue(props, `evaluator_ID[${0}]`, {})}
                            label="label"
                            id="id"
                            name="Evaluator"
                            resetInput={resetInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex w-100 filter-field-main-wrap">
                      <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                        <label
                          htmlFor="rule"
                          className="filter-form-wrappper__label filter-fields-label"
                        >
                          Function Head
                        </label>
                        <div className="filter-form-wrappper__location-input select-dd-new">
                          <SearchableDropdownSelect
                            placeholder={"Choose Function Head"}
                            options={props.FunctionHead}
                            searchLoading={props.FunctionHeadLoading}
                            handleChange={(val: any) =>
                              props.getFunctionHead(val)
                            }
                            handleClick={(e: any) =>
                              props.handleChangeSelect(e, "function_head")
                            }
                            value={getValue(
                              props,
                              `function_head_ID[${0}]`,
                              {}
                            )}
                            label="label"
                            id="id"
                            name="Function Head"
                            resetInput={resetInput}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {additionalFilter && (
                  <div className="filter-form-wrappper__container border-0">
                    <div className="d-flex w-100 filter-field-main-wrap">
                      {/* <div className="filter-form-wrappper__location flex-1 mb-0 d-flex"> */}
                      <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                        <label
                          htmlFor="rule"
                          className="filter-form-wrappper__label filter-fields-label"
                        >
                          Additional Filter
                        </label>
                        <div className="filter-form-wrappper__location-input">
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose Additional Filter"
                            className="form-control"
                            name="legislation_rule_id"
                            id="legislation_rule_id"
                            label="Legislation Rule ID"
                            options={smartFilterList}
                            value={selectedSmartFilterIds}
                            onChange={(e: any) => handleChangeSelectMulti(e)}
                            isMulti
                          />
                        </div>
                      </div>
                      {getValue(props, `compliance_status_filter`, "") && (
                        <div
                          className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap"
                          // style={{ marginLeft: "18px" }}
                        >
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Compliance Status
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Compliance Status"
                              className="form-control w-100"
                              name="compliance_status"
                              id="compliance_status"
                              label="Compliance Status"
                              options={getValue(
                                props,
                                `complianceStatusOptions`,
                                []
                              )}
                              value={getValue(
                                props,
                                `compliance_status_ID[${0}]`,
                                ""
                              )}
                              onChange={(e: any) =>
                                handleChangeSelectByValue(
                                  e,
                                  "compliance_status"
                                )
                              }
                            />
                          </div>
                        </div>
                      )}

                      {getValue(props, `hideActive`, false) && (
                        <div>
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Show Inactive
                          </label>
                          <br />
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={
                                  getValue(props, `request.status`, "") ===
                                  "inactive"
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  props.handleChangeSelectByDirectValue(
                                    getValue(props, `request.status`, "") ===
                                      "inactive"
                                      ? "active"
                                      : "inactive",
                                    "status"
                                  )
                                }
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="filter-form-wrappper__cta-wrapper d-none">
          {/* {props.country_ID.length > 0 ? ( */}
          <button
            className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
            onClick={props.handleSubmitSmartFilter}
          >
            Search
          </button>
          {/* ) : (
            <button
              className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--disable"
              onClick={props.handleSubmitSmartFilter}
            >
              Search
            </button>
          )} */}
          <button
            className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
            onClick={props.reset}
          >
            Reset
          </button>
        </div>

        {/* <AddFilterNew /> */}
      </div>
    </div>
  );
}
